export default __webpack_public_path__ + "static/media/AI.ddc46690.jpg";